export default [
  {
    title: 'ترخیص‌کاران',
    icon: 'bx bx-id-card',
    children: [
      {
        title: 'ترخیص‌کاران',
        route: { name: 'agent' },
        resource: 'AgentManager',
        action: 'show',
      },
    ],
  },
]
